document.addEventListener("DOMContentLoaded", () => {
    const triggers = document.querySelectorAll("[data-trigger]");

    triggers.forEach((trigger) => {
        trigger.addEventListener("mouseenter", () => {
            const id = trigger.dataset.trigger;
            const panel = document.querySelector(`[data-panel="${id}"]`);
            if (!panel) return;

            panel.classList.add("open");

            const triggerRect = trigger.getBoundingClientRect();
            const panelWidth = panel.offsetWidth;
            const triggerCenter = triggerRect.left + triggerRect.width / 2;
            const panelLeft = triggerCenter - panelWidth / 2;

            panel.style.left = `${panelLeft}px`;

            const arrow = panel.querySelector(".alpha-dropdown-arrow");
            const arrowLeft = triggerCenter - panelLeft;
            arrow.style.left = `${arrowLeft}px`;
        });

        trigger.addEventListener("mouseleave", () => {
            const id = trigger.dataset.trigger;
            const panel = document.querySelector(`[data-panel="${id}"]`);
            if (panel) panel.classList.remove("open");
        });
    });
});